import React from 'react';
import {Item, Section} from '../components/types';
import {useVeiledere} from '../context/VeilederContext';

const extractFagSections = (data: any): Section[] => {
  const sections: Section[] = [];

  if (data && data.fag && data.fag.links) {
    data.fag.links.forEach((category: {links: any; name: any}) => {
      if (category.links) {
        sections.push({
          title: category.name,
          data: category.links,
        });
      }
    });
  }

  return sections;
};

const FagScreen = () => {
  const veiledere = useVeiledere();

  const sections = veiledere ? extractFagSections(veiledere) : [];

  return (
    <div className="screenContainer">
      {sections.length > 0 ? (
        sections.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            <h2 className="sectionHeader sectionHeaderFag">{section.title}</h2>
            <ul>
              {section.data.map((item: Item, itemIndex) => (
                <li key={itemIndex}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkButton">
                    <span className="linkText">{item.name}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))
      ) : (
        <p>Henter ny informasjon...</p>
      )}
    </div>
  );
};

export default FagScreen;
